import React, { useEffect, useState } from 'react';
import './QuickBatchDrawer.css';
import { Button, Checkbox, Collapse, Input, message } from 'antd';
import { FiEdit2 } from 'react-icons/fi';
import { MdKeyboardBackspace } from 'react-icons/md';
import { FaPen } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa6';
import { MdDeleteOutline } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import {
    quick_Action_Run_Generate_ChunksHandler,
    quick_Action_Run_Generate_Chunks_Success,
} from '../../../../Redux/Actions/user/RunQuickActionGenerateChunks';
import Loader from '../../../../Components/Loader/Loader';
import { quick_Action_Run_Save_Execute_BatchHandler } from '../../../../Redux/Actions/user/RunQuickActionSaveExecuteBatch';
import {
    quick_Action_Run_Status_ActionHandler,
    quick_Action_Run_Status_Success,
} from '../../../../Redux/Actions/user/RunQuickActionStatus';
import Swal from 'sweetalert2';

const { TextArea } = Input;

const { Panel } = Collapse;
const QuickBatchDrawer = ({
    quickRunId,
    quickActionId,
    BatchProcessing,
    batchOverlay,
    statusData,
    setQuickSaveExecuteResponse,
    loader,
    setisEditQuickBatch,
    isEditQuickBatch,
    setShowCheckbox,
    showCheckbox,
    batchSizeBox,
    setBatchSizeBox,
    setBatchKeyWordbox,
    batchKeywordbox,
    setSummararizebatchbox,
    Summararizebatchbox,
    setEditSummary,
    EditSummary,
    setSaveExecuteStatushandle,
    setcontinuesLoader,
    continuesLoader,
    setIsBatchOpen,
    setTableFlutuationOff,
    tableFlutuationOff,
    setLoaderwill,
    loaderwill,
    IsBatchOnLargeData,
}) => {
    let dispatch = useDispatch();
    // const [isEditQuickBatch, setisEditQuickBatch] = useState(false);
    // const [showCheckbox, setShowCheckbox] = useState(true);
    // const [batchSizeBox, setBatchSizeBox] = useState("");
    // const [batchKeywordbox, setBatchKeyWordbox] = useState("");
    const [startKeyword, setStartKeyword] = useState('');
    const [endKeyword, setEndKeyword] = useState('');
    const [ChunksOFData, setChunksOFData] = useState([]);
    const [statusQaOnChunks, setstatusQaOnChunks] = useState('');
    // const [Summararizebatchbox, setSummararizebatchbox] = useState("");
    const [batchPrompt, setBatchPrompt] = useState(
        'Combine these sections into 1 following the guidelines as set out in the below. Include all of the information, but improve the layout to avoid duplication.'
    );
    // const [EditSummary, setEditSummary] = useState(false);
    // const [loaderwill, setLoaderwill] = useState(false);
    // const [tableFlutuationOff, setTableFlutuationOff] = useState(false);

    const QuickRunChunkData = useSelector(
        (state) =>
            state?.quick_Action_Run_Generate_Chunks_Data
                ?.quick_Action_Run_Generate_Chunks_data?.data
    );

    const quickrunStatusData = useSelector(
        (state) =>
            state?.quick_Action_Run_Status_Data?.quick_Action_Run_Status_data
                ?.data
    );

    const QuicksaveExecute = useSelector(
        (state) =>
            state?.quick_Action_Run_Save_Execute_Batch_Data
                ?.quick_Action_Run_Save_Execute_Batch_data?.data
    );

    const QuicksaveExecuteLoader = useSelector(
        (state) => state?.quick_Action_Run_Save_Execute_Batch_Data?.loader
    );

    useEffect(() => {
        if (quickrunStatusData) {
            setstatusQaOnChunks(quickrunStatusData?.status);
        }
    }, [quickrunStatusData]);

    // useEffect(() => {
    //   if (statusQaOnChunks === "SUCCESS" || statusQaOnChunks === "FAILED") {
    //     setcontinuesLoader(false);
    //     setIsBatchOpen(false);
    //     setLoaderwill(false);
    //   }
    // }, [quickrunStatusData?.status]);

    useEffect(() => {
        if (
            quickrunStatusData?.batch?.status === 'CHUNKED' ||
            quickrunStatusData?.batch?.status === 'FAILED'
            // quickrunStatusData?.status === "BATCHING"
        ) {
            setLoaderwill(false);
        }
    }, [quickrunStatusData?.batch?.status]);

    useEffect(() => {
        if (
            quickrunStatusData?.batch?.status &&
            QuickRunChunkData?.action_run_id
        ) {
            if (
                statusQaOnChunks === 'SUCCESS' ||
                quickrunStatusData?.batch?.status === 'COMPLETED'
            ) {
                setcontinuesLoader(false);
                setIsBatchOpen(false);
                setTableFlutuationOff(false);

                dispatch(quick_Action_Run_Generate_Chunks_Success(null));
            } else if (
                quickrunStatusData?.batch?.status &&
                QuickRunChunkData?.action_run_id &&
                quickrunStatusData?.batch?.status !== 'CHUNKED' &&
                quickrunStatusData?.batch?.status !== 'FAILED' &&
                !QuicksaveExecute
            ) {
                setLoaderwill(true);

                setTimeout(() => {
                    dispatch(
                        quick_Action_Run_Status_ActionHandler(
                            quickActionId,
                            QuickRunChunkData?.action_run_id
                        )
                    );
                }, 4000);
            }
        }
    }, [quickrunStatusData, QuickRunChunkData?.action_run_id]);

    // useEffect(() => {
    //   if (statusQaOnChunks === "BATCHING") {
    //     setTimeout(() => {
    //       dispatch(
    //         quick_Action_Run_Status_ActionHandler(
    //           quickActionId,
    //           QuickRunChunkData?.action_run_id
    //         )
    //       );
    //     }, 2000);
    //   }
    // }, [quickrunStatusData, statusQaOnChunks, QuickRunChunkData]);

    useEffect(() => {
        if (
            QuickRunChunkData?.batch?.status === 'PENDING' &&
            QuickRunChunkData?.action_run_id
        ) {
            setTimeout(() => {
                dispatch(
                    quick_Action_Run_Status_ActionHandler(
                        quickActionId,
                        QuickRunChunkData?.action_run_id
                    )
                );
            }, 2000);
        }
    }, [QuickRunChunkData]);

    useEffect(() => {
        if (
            (QuickRunChunkData &&
                QuickRunChunkData.batch &&
                QuickRunChunkData.batch.chunks) ||
            (quickrunStatusData &&
                quickrunStatusData.batch &&
                quickrunStatusData.batch.chunks)
        ) {
            const modifiedChunks = [];

            if (
                QuickRunChunkData &&
                QuickRunChunkData.batch &&
                QuickRunChunkData.batch.chunks
            ) {
                modifiedChunks.push(
                    ...QuickRunChunkData.batch.chunks.map((chunk) => ({
                        ...chunk,
                        auto_batch_on_token_exceed:
                            chunk?.auto_batch_on_token_exceed ? true : false,
                    }))
                );
            }

            if (
                quickrunStatusData &&
                quickrunStatusData.batch &&
                quickrunStatusData.batch.chunks
            ) {
                modifiedChunks.push(
                    ...quickrunStatusData.batch.chunks.map((chunk) => ({
                        ...chunk,
                        auto_batch_on_token_exceed:
                            chunk?.auto_batch_on_token_exceed ? true : false,
                    }))
                );
            }

            setChunksOFData(modifiedChunks);
        }
    }, [QuickRunChunkData, quickrunStatusData]);

    const QuickRunChunkDataLoader = useSelector(
        (state) => state?.quick_Action_Run_Generate_Chunks_Data?.loader
    );

    const handleEditQuickBatch = () => {
        setisEditQuickBatch(!isEditQuickBatch);
    };

    const handleStartKeywordChange = (event) => {
        setStartKeyword(event.target.value);
    };

    const handleEndKeywordChange = (event) => {
        setEndKeyword(event.target.value);
    };

    const genExtra = (i) => (
        <MdDeleteOutline
            className='delete-batch'
            onClick={(event) => {
                handleChunksDeleted(i);
                event.stopPropagation();
            }}
        />
    );

    const handleChunksDeleted = (i) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this batch?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    position: 'centre',
                    icon: 'success',
                    title: 'Batch has been deleted successfully',
                    showConfirmButton: false,
                    timer: 1000,
                });
                let newData = ChunksOFData?.slice(0, i).concat(
                    ChunksOFData?.slice(i + 1)
                );
                setChunksOFData(newData);
            }
        });
    };

    const handleEditContent = (index, editedContent) => {
        const updatedChunksOFData = [...ChunksOFData];

        updatedChunksOFData[index] = {
            ...updatedChunksOFData[index],
            chunk: editedContent,
            token_count: countTokens(editedContent),
        };

        const wordCount = editedContent
            ?.trim()
            .split(/\s+/)
            .filter(Boolean).length;

        updatedChunksOFData[index].wordCount = wordCount;

        setChunksOFData(updatedChunksOFData);
    };

    const countTokens = (text) => {
        const tokens = text?.split(/\s+/);
        const nonEmptyTokens = tokens?.filter((token) => token?.length > 0);
        return nonEmptyTokens?.length;
    };

    const handleAddNewBatches = () => {
        const newBatch = {
            auto_batch_on_token_exceed: false,
            chunk: '',
            error_details: null,
            error_message: null,
            error_type: null,
            status: null,
            token_count: 0,
        };

        setChunksOFData([...ChunksOFData, newBatch]);
    };
    const calculateWordCount = (text) => {
        const trimmedText = text?.trim();
        if (!trimmedText) {
            return '0';
        }

        const wordsArray = trimmedText?.split(/\s+/);

        const wordCount = wordsArray?.length;

        return wordCount?.toLocaleString();
    };

    const handleAutoBatchExeed = (index, checked) => {
        const newChunks = [...ChunksOFData];
        newChunks[index].auto_batch_on_token_exceed = checked;
        setChunksOFData(newChunks);
    };

    const items =
        quickrunStatusData &&
        quickrunStatusData?.batch &&
        ChunksOFData?.map((chunk, index) => {
            const isChunkOverLimit =
                chunk?.status === 'FAILED' ||
                chunk?.token_count >
                    quickrunStatusData?.batch?.chunk_token_limit;
            return {
                key: index?.toString(),
                label: (
                    <span
                        className={
                            isChunkOverLimit
                                ? 'chunk-red-text'
                                : 'chunk-green-text'
                        }>
                        {`Batch ${index + 1} ` +
                            ' (Maximum Batch Size ' +
                            calculateWordCount(chunk?.chunk) +
                            ' of ' +
                            quickrunStatusData?.batch?.chunk_word_limit?.toLocaleString() +
                            ')'}

                        {chunk?.is_token_exceeded && (
                            <div>
                                This batch is too large and will need to be
                                auto-batched
                            </div>
                        )}
                    </span>
                ),
                children: (
                    <div>
                        <textarea
                            className={`batches-chunks-text ${
                                isChunkOverLimit
                                    ? 'chunk-red-text'
                                    : 'chunk-green-text'
                            }`}
                            dir='ltr'
                            value={chunk?.chunk}
                            onChange={(e) =>
                                handleEditContent(index, e.target.value)
                            }
                        />

                        <p
                            className={`token-count_on-chunks ${
                                isChunkOverLimit
                                    ? 'chunk-red-text'
                                    : 'chunk-green-text'
                            }`}>
                            Token Size:
                            {'(  ' +
                                chunk?.token_count?.toLocaleString() +
                                ' Tokens Of ' +
                                quickrunStatusData?.batch?.chunk_token_limit?.toLocaleString() +
                                ' Tokens ' +
                                '  )'}
                        </p>
                        {chunk?.is_token_exceeded && (
                            <div className='auto-batch-error-checkbox'>
                                <Checkbox
                                    className='quick-batch-checkbox form-custom-checkbox'
                                    onChange={(e) =>
                                        handleAutoBatchExeed(
                                            index,
                                            e.target.checked
                                        )
                                    }
                                    checked={chunk?.auto_batch_on_token_exceed}
                                />
                                <strong>Auto-batch by size</strong>{' '}
                            </div>
                        )}
                    </div>
                ),
                extra: genExtra(index),
            };
        });

    const handleCheckboxChangeKeyword = (event) => {
        setBatchKeyWordbox(event.target.checked ? 'keyword' : '');
        setBatchSizeBox('');
    };

    const handleCheckboxChangeBySize = (event) => {
        setBatchSizeBox(event.target.checked ? 'size' : '');
        setBatchKeyWordbox('');
    };

    const handleGenerateChunKAPI = () => {
        if (batchKeywordbox === 'keyword') {
            if (startKeyword === '' && endKeyword === '') {
                message.error('Please fill in all required fields');
                setShowCheckbox(true);
                return;
            }
        }

        let request = {
            action_run_id: quickRunId,
            type: batchKeywordbox || batchSizeBox,
            ...(startKeyword !== '' && { start_keyword: startKeyword }),
            ...(endKeyword !== '' && { end_keyword: endKeyword }),
        };

        dispatch(
            quick_Action_Run_Generate_ChunksHandler(request, quickActionId)
        );
    };

    useEffect(() => {
        if (QuicksaveExecute?.status) {
            setQuickSaveExecuteResponse(QuicksaveExecute);
            // batchOverlay();
            setcontinuesLoader(true);
            setTableFlutuationOff(true);
            setStartKeyword('');
            setEndKeyword('');
        }
    }, [QuicksaveExecute]);

    useEffect(() => {
        if (
            QuicksaveExecute?.batch &&
            QuicksaveExecute?.batch?.status === 'VALIDATING' &&
            QuickRunChunkData?.action_run_id
        ) {
            setTimeout(() => {
                dispatch(
                    quick_Action_Run_Status_ActionHandler(
                        quickActionId,
                        QuickRunChunkData?.action_run_id
                    )
                );
                setSaveExecuteStatushandle(true);
            }, 3000);
        }
    }, [QuicksaveExecute?.status]);

    const handlesave_execute_batch = () => {
        let request = {
            action_run_id: quickRunId,
            chunks: ChunksOFData,
            include_quick_action_as_summary: false,
            do_not_summarize_final_result: Summararizebatchbox ? true : false,
            // ...(batchPrompt && { summary_prompt: batchPrompt }),

            summary_prompt: batchPrompt,
        };

        dispatch(
            quick_Action_Run_Save_Execute_BatchHandler(request, quickActionId)
        );
    };

    const handleEditSummaryCheckBox = (e) => {
        // const checked = e.target.checked;
        // setSummararizebatchbox(checked);
        setSummararizebatchbox(!Summararizebatchbox);
        // setBatchPrompt("");
    };

    return (
        <div className='quick-batch-main'>
            {(QuickRunChunkDataLoader || QuicksaveExecuteLoader) && <Loader />}
            {/* && !statusData?.batch?.chunks */}
            {(loaderwill || loader || continuesLoader) && (
                <div className='temportal-loader-overlay'>
                    <div className='temporal-loader'></div>
                </div>
            )}
            {showCheckbox && (
                <div>
                    <div className='quick-batch-1'>
                        <h2>Quick Batch Data</h2>
                    </div>
                    <p className='quick-batch-p'>
                        Please select a method of separating your data below
                    </p>
                    {!IsBatchOnLargeData && (
                        <div className='quick-batch-batches-div'>
                            <Checkbox
                                className='quick-batch-checkbox form-custom-checkbox'
                                checked={batchSizeBox}
                                onChange={handleCheckboxChangeBySize}
                            />
                            <div>
                                <strong>Batch By Size</strong> <br />
                                AutoBatch your data by the maximum chunk size.
                            </div>
                        </div>
                    )}

                    <div className='quick-batch-batches-div'>
                        <Checkbox
                            className='quick-batch-checkbox form-custom-checkbox'
                            checked={batchKeywordbox}
                            onChange={handleCheckboxChangeKeyword}
                        />
                        <div>
                            <strong>Batch By Keyword</strong> <br />
                            Batch your data by keywords in the text.
                        </div>
                    </div>

                    {batchKeywordbox && (
                        <div>
                            <div className='input-batch-div'>
                                <Input
                                    placeholder='Start Keyword  (the Beginning of each batch)'
                                    value={startKeyword}
                                    onChange={handleStartKeywordChange}
                                />
                            </div>

                            <div>
                                <Input
                                    placeholder='End Keyword  (the end of each batch)'
                                    value={endKeyword}
                                    onChange={handleEndKeywordChange}
                                />
                            </div>
                        </div>
                    )}

                    <Button
                        className='main-api btn-batch'
                        onClick={() => {
                            setShowCheckbox(false);

                            handleGenerateChunKAPI();
                        }}>
                        Next
                    </Button>
                </div>
            )}

            {/*  */}
            {!showCheckbox && (
                <>
                    {!isEditQuickBatch ? (
                        <div>
                            <div className='quick-batch-1'>
                                <h2>Quick Batch</h2>
                                {/* <Button className="main-api ">Action</Button> */}
                                <div
                                    className='drawer-back'
                                    onClick={() => {
                                        setShowCheckbox(true);
                                    }}>
                                    <MdKeyboardBackspace />
                                    Back
                                </div>
                            </div>

                            <p className='quick-batch-p'>
                                This data is large and will use multiple credits
                                Due to the size, please note this process may
                                take longer than usual'
                            </p>
                            <p className='quick-batch-p'>
                                You can also view and edit how this data is
                                batched before running your QuickAction
                            </p>

                            <div className='total-cout-div'>
                                <p>
                                    Total word count:{' '}
                                    {QuickRunChunkData?.batch?.prompt_word_count?.toLocaleString()}
                                </p>
                                <p>
                                    Batch size:{' '}
                                    {QuickRunChunkData &&
                                        QuickRunChunkData?.batch?.chunk_token_limit?.toLocaleString()}
                                </p>
                                <p>
                                    Total batches:{' '}
                                    {(QuickRunChunkData &&
                                        quickrunStatusData?.batch?.chunks
                                            ?.length) ||
                                        QuickRunChunkData?.batch?.chunks
                                            ?.length ||
                                        0}
                                </p>
                            </div>
                            {quickrunStatusData?.batch?.chunks?.length && (
                                <div
                                    className='supporting-document-out-image-button edit-btn-batch'
                                    onClick={handleEditQuickBatch}>
                                    <FiEdit2 className='supporting-document-out-sideIcon-size supporting-document-out-color-text' />{' '}
                                    Edit Batches and See Details
                                </div>
                            )}
                        </div>
                    ) : (
                        <div>
                            <div className='quick-batch-1'>
                                <h2>Quick Batch</h2>
                                <div
                                    className='backArrow-div'
                                    onClick={handleEditQuickBatch}>
                                    <MdKeyboardBackspace />
                                    Back
                                </div>
                            </div>
                            <p className='quick-batch-p'>
                                You can also view and edit how this data is
                                batched before running your QuickAction
                            </p>
                            {!tableFlutuationOff ? (
                                <div className='accodian-batch-container'>
                                    <Collapse
                                        className='custom-collapse'
                                        items={items}
                                        defaultActiveKey={['0']}
                                        accordion>
                                        {items?.map((item) => (
                                            <Panel
                                                header={item?.label}
                                                key={item?.key}
                                                extra={item?.extra}>
                                                {item?.children}
                                            </Panel>
                                        ))}
                                    </Collapse>
                                </div>
                            ) : (
                                <h2>
                                    Batch processing is in progress. Please
                                    wait...{' '}
                                </h2>
                            )}
                            <div className='edit-execute-summary'>
                                <div className='supporting-document-out-upload-middle-div-tree-p'>
                                    <button
                                        className='edit-sumamry-btn'
                                        onClick={() =>
                                            setEditSummary(!EditSummary)
                                        }>
                                        <FaPen className='supporting-document-out-sideIcon-size supporting-document-out-color-text' />{' '}
                                        Edit Summary{' '}
                                    </button>
                                </div>

                                <div className='supporting-document-out-upload-middle-div-tree-p'>
                                    <button
                                        onClick={handleAddNewBatches}
                                        className='edit-sumamry-btn '>
                                        <FaPlus className='supporting-document-out-sideIcon-size supporting-document-out-color-text' />{' '}
                                        Add Batches
                                    </button>
                                </div>
                            </div>
                            <div>
                                <div className='quick-batch-checkbox-div'>
                                    <div>
                                        <Checkbox
                                            className='quick-batch-checkbox form-custom-checkbox'
                                            checked={Summararizebatchbox}
                                            onChange={handleEditSummaryCheckBox}
                                        />
                                        <strong>
                                            Do not summarise the response.
                                        </strong>{' '}
                                    </div>

                                    <p>
                                        Selecting this option will run each
                                        batch as a separate QuickAction.
                                    </p>
                                    {/* <p>Please note,this may overlay with your output.</p> */}
                                </div>

                                {EditSummary && (
                                    <div className='execiute-save-textArea'>
                                        <p>Summary QuickBatch Prompt</p>
                                        <TextArea
                                            onChange={(e) =>
                                                setBatchPrompt(e.target.value)
                                            }
                                            rows={4}
                                            value={batchPrompt}
                                            placeholder='This is the set of instructions to combine the batches to create one output'
                                        />
                                    </div>
                                )}
                            </div>

                            {/* {quickrunStatusData?.batch?.status === "FAILED" ? null : ( */}
                            <Button
                                className='delete-refer-data-supporting-button action-back-btn'
                                onClick={() => {
                                    handlesave_execute_batch();
                                }}>
                                Action
                            </Button>
                            {/* )} */}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default QuickBatchDrawer;
